import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-1 table-striped table-hover",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "" }, null, -1)
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}

import { ref, onMounted, nextTick } from "vue";
import AccountService from "../services/AccountService";
import OpenProcedureForm from "../components/OpenProcedureForm.vue";
import TimeShow from "@/components/TimeShow.vue";
import i18n from "@/core/plugins/i18n";
import TableFooter from "@/components/TableFooter.vue";
import AccountDetail from "../components/AccountDetail.vue";
import GlobalService from "@/projects/client/services/ClientGlobalService";
import { ServiceMapType } from "@/core/types/ServiceTypes";
import { reinitializeComponents } from "@/core/plugins/plugins";
import { ArrowDown } from "@element-plus/icons-vue";
// import { Search } from "@element-plus/icons-vue";

import CommentsView from "../../../components/CommentView.vue";
import { CommentType } from "@/core/types/CommentType";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountsIndex',
  setup(__props) {

const { t } = i18n.global;

const openProcedureFormRef = ref<InstanceType<typeof OpenProcedureForm>>();
const accountDetailRef = ref<any>(null);
const commentsRef = ref<InstanceType<typeof CommentsView>>();

const isLoading = ref(true);
const liveAccounts = ref(Array<any>());
const serviceMap = ref<ServiceMapType>({} as ServiceMapType);

const criteria = ref<any>({
  page: 1,
  size: 20,
  numPages: 1,
  total: 0,
  hasTradeAccount: true,
  sortField: "CreatedOn",
});

const paymentServiceCriteria = ref({
  size: 100,
});

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const responseBody = await AccountService.queryAccounts(criteria.value);
    criteria.value = responseBody.criteria;
    liveAccounts.value = responseBody.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
    await nextTick();
    reinitializeComponents();
  }
};

onMounted(async () => {
  isLoading.value = true;
  serviceMap.value = await GlobalService.getServiceMap();
  await fetchData(1);
  isLoading.value = false;
});

const viewComments = (type: CommentType, id: number, title: string) => {
  commentsRef.value?.show(type, id, title);
};

const showAccountDetail = (id: number, page: string) => {
  accountDetailRef.value.show(id, page, [] as any);
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_AccountStatusBadge = _resolveComponent("AccountStatusBadge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.accounts")), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.status")), 1),
            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.id")), 1),
            _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.type")), 1),
            _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.currency")), 1),
            _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.tradeAccount")), 1),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.name")), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.group")), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.role")), 1),
            _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("fields.server")), 1),
            _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("fields.sales")), 1),
            _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t("fields.ib")), 1),
            _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("fields.accountCode")), 1),
            _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("title.rebate")), 1),
            _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t("fields.created_at")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && liveAccounts.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_24, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveAccounts.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_dropdown, { trigger: "click" }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (
                        openProcedureFormRef.value?.show(3, {
                          accountId: item.id,
                        })
                      )
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("tip.accountOpenProcedure")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'infos'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.details")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'trade'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.tradeHistory")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'transaction'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.transferHistory")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              (item.role == 400)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 0,
                                    onClick: ($event: any) => (showAccountDetail(item.id, 'rebate'))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("title.rebate")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'documents'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.documents")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            class: "btn btn-secondary btn-sm"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.action")), 1),
                              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ArrowDown))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_AccountStatusBadge, {
                        status: item.status
                      }, null, 8, ["status"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        role: "button",
                        onClick: ($event: any) => (
                  viewComments(
                    _unref(CommentType).Account,
                    item.id,
                    item.user.firstName +
                      '' +
                      item.user.lastName +
                      '-' +
                      item.id
                  )
                )
                      }, [
                        _createTextVNode(_toDisplayString(item.uid) + " ", 1),
                        (item.hasComment)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_26)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.account.${item.type}`)), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(t)(`type.currency.${item.tradeAccount?.currencyId}`)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.tradeAccount?.accountNumber), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        role: "button",
                        onClick: ($event: any) => (
                  viewComments(
                    _unref(CommentType).User,
                    item.user.partyId,
                    item.user.firstName + ' ' + item.user.lastName
                  )
                )
                      }, [
                        _createTextVNode(_toDisplayString(item.user.firstName) + " " + _toDisplayString(item.user.lastName) + " ", 1),
                        (item.user.hasComment)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_28)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.group), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.accountRole.${item.role}`)), 1),
                    _createElementVNode("td", null, _toDisplayString(serviceMap.value[item.serviceId]?.serverName), 1),
                    _createElementVNode("td", null, [
                      (item.salesAccount.id == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, "No Sales"))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            role: "button",
                            onClick: ($event: any) => (
                  viewComments(
                    _unref(CommentType).Account,
                    item.salesAccount.id,
                    item.salesAccount.user.firstName +
                      ' ' +
                      item.salesAccount.user.lastName
                  )
                )
                          }, [
                            _createTextVNode(" [" + _toDisplayString(item.salesAccount.user.firstName) + " " + _toDisplayString(item.salesAccount.user.lastName) + "] " + _toDisplayString(item.salesAccount.uid) + " ", 1),
                            (item.salesAccount.hasComment)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_32))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_31))
                    ]),
                    _createElementVNode("td", null, [
                      (item.agentAccount.id == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, "No IB"))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            role: "button",
                            onClick: ($event: any) => (
                  viewComments(
                    _unref(CommentType).Account,
                    item.agentAccount.id,
                    item.agentAccount.user.firstName +
                      ' ' +
                      item.agentAccount.user.lastName
                  )
                )
                          }, [
                            _createTextVNode("[" + _toDisplayString(item.agentAccount.user.firstName) + " " + _toDisplayString(item.agentAccount.user.lastName) + "] " + _toDisplayString(item.agentAccount.uid) + " ", 1),
                            (item.agentAccount.hasComment)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_34))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.code), 1),
                    _createElementVNode("td", null, _toDisplayString(item.agentRebateRule), 1),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(AccountDetail, {
      ref_key: "accountDetailRef",
      ref: accountDetailRef
    }, null, 512),
    _createVNode(OpenProcedureForm, {
      ref_key: "openProcedureFormRef",
      ref: openProcedureFormRef
    }, null, 512),
    _createVNode(CommentsView, {
      ref_key: "commentsRef",
      ref: commentsRef,
      type: "",
      id: "0"
    }, null, 512)
  ]))
}
}

})